// kontakt/index.jsx

import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  TextField,
  Button,
  useTheme,
  useMediaQuery,
  InputAdornment,
  Grid,
  FormHelperText,
} from '@mui/material';
import Navbar from 'scenes/widgets/navbar';
import Footer from 'scenes/widgets/footer';
import './styles.css';

const ErlaubnisPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery('(max-width:999px)');
  const [isLoading, setIsLoading] = useState(true);
  
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 100);

    return () => clearTimeout(timer); // Cleanup on unmount
  }, []);
  
  useEffect(() => {
    // Set global variables that the form expects
    window.REQUIRED_CODE_ERROR_MESSAGE = 'Bitte wählen Sie eine Landesvorwahl aus';
    window.LOCALE = 'de';
    window.EMAIL_INVALID_MESSAGE = window.SMS_INVALID_MESSAGE = "Die angegebenen Informationen sind ungültig. Bitte überprüfen Sie das Feldformat und versuchen Sie es erneut.";
    window.REQUIRED_ERROR_MESSAGE = "Dieses Feld darf nicht leer bleiben. ";
    window.GENERIC_INVALID_MESSAGE = "Die angegebenen Informationen sind ungültig. Bitte überprüfen Sie das Feldformat und versuchen Sie es erneut.";
    window.INVALID_NUMBER = "Die angegebenen Informationen sind ungültig. Bitte überprüfen Sie das Feldformat und versuchen Sie es erneut.";
    window.INVALID_DATE = "Bitte geben Sie ein gültiges Datum ein";
    window.KUENSTLERNAME_ERROR_MESSAGE = "Der Künstlername muss zwischen 2 und 20 Zeichen lang sein und darf nur lateinische Buchstaben, Zahlen, Punkte (.) und Unterstriche (_) enthalten.";

    window.translation = {
      common: {
        selectedList: '{quantity} list selected',
        selectedLists: '{quantity} lists selected',
        selectedOption: '{quantity} selected',
        selectedOptions: '{quantity} selected',
      }
    };

    window.AUTOHIDE = Boolean(0);

    const script = document.createElement('script');
    script.src = 'https://sibforms.com/forms/end-form/build/main.js';
    script.defer = true;
    document.body.appendChild(script);

    const addKuenstlernameValidation = () => {
      const kuenstlernameField = document.getElementById('BENUTZERNAME_KK');

      if (kuenstlernameField) {
        kuenstlernameField.addEventListener('input', function (e) {
          const value = e.target.value;
          const isValid = /^[a-zA-Z0-9._]{2,20}$/.test(value);
          if (!isValid && value.length > 0) {
            e.target.setCustomValidity('Der Künstlername muss zwischen 2 und 20 Zeichen lang sein und darf nur lateinische Buchstaben, Zahlen, Punkte (.) und Unterstriche (_) enthalten.');
          } else {
            e.target.setCustomValidity('');
          }
        });

        kuenstlernameField.addEventListener('blur', function (e) {
          const value = e.target.value;
          if (value.length > 0 && value.length < 2) {
            e.target.setCustomValidity('Der Künstlername muss mindestens 2 Zeichen lang sein.');
          } else if (value.length > 20) {
            e.target.setCustomValidity('Der Künstlername darf maximal 20 Zeichen lang sein.');
          } else if (!/^[a-zA-Z0-9._]*$/.test(value)) {
            e.target.setCustomValidity('Der Künstlername darf nur lateinische Buchstaben, Zahlen, Punkte (.) und Unterstriche (_) enthalten.');
          } else {
            e.target.setCustomValidity('');
          }
        });

        kuenstlernameField.addEventListener('invalid', function (e) {
          const value = e.target.value;

          if (value.length === 0) {
            // Keep default required message for empty field
            return;
          }

          // Override with custom validation message for format errors
          if (value.length < 2 || value.length > 20 || !/^[a-zA-Z0-9._]*$/.test(value)) {
            e.target.setCustomValidity('Der Künstlername muss zwischen 2 und 20 Zeichen lang sein und darf nur lateinische Buchstaben, Zahlen, Punkte (.) und Unterstriche (_) enthalten.');

            // Also update the error label directly
            const errorLabel = e.target.closest('.form__entry').querySelector('.entry__error--primary');
            if (errorLabel) {
              errorLabel.textContent = 'Der Künstlername muss zwischen 2 und 20 Zeichen lang sein und darf nur lateinische Buchstaben, Zahlen, Punkte (.) und Unterstriche (_) enthalten.';
            }
          }
        });

        // Add form submit listener
        const form = document.getElementById('sib-form');
        if (form) {
          form.setAttribute('novalidate', 'true');

          const blockIfInvalid = (e) => {
            const value = kuenstlernameField.value.trim();
            const invalid = value.length < 2 || value.length > 20 || !/^[a-zA-Z0-9._]+$/.test(value);

            if (invalid) {
              e.preventDefault();
              e.stopPropagation();
              if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

              kuenstlernameField.setCustomValidity('Der Künstlername muss zwischen 2 und 20 Zeichen lang sein und darf nur lateinische Buchstaben, Zahlen, Punkte (.) und Unterstriche (_) enthalten.');
              const errorLabel = kuenstlernameField.closest('.form__entry').querySelector('.entry__error--primary');
              if (errorLabel) {
                errorLabel.style.display = 'block';
                errorLabel.textContent = 'Der Künstlername muss zwischen 2 und 20 Zeichen lang sein und darf nur lateinische Buchstaben, Zahlen, Punkte (.) und Unterstriche (_) enthalten.';
              }
              kuenstlernameField.focus();
            } else {
              kuenstlernameField.setCustomValidity('');
            }
          };

          form.addEventListener('submit', blockIfInvalid, true);
          form.addEventListener('submit', blockIfInvalid);
        }

      }
    };

    // Try to add validation immediately if DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', addKuenstlernameValidation);
    } else {
      // DOM already loaded, try adding validation with a small delay to ensure form is rendered
      setTimeout(addKuenstlernameValidation, 100);
    }

    return () => {
      document.body.removeChild(script);
      
      const countryLists = document.querySelectorAll('.sib-sms-select__list');
      countryLists.forEach(list => list.remove());
    };
  }, []);

  return (
    <Box>
      <Navbar />

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          visibility: isLoading ? 'hidden' : 'visible',
          '& iframe': {
            maxWidth: '100%',
          }
        }}
      >
        <div
          dangerouslySetInnerHTML={{
            __html: `<!-- Begin Brevo Form -->
<!-- START - We recommend to place the below code in head tag of your website html  -->
<link rel="stylesheet" href="https://sibforms.com/forms/end-form/build/sib-styles.css">
<!--  END - We recommend to place the above code in head tag of your website html -->

<!-- START - We recommend to place the below code where you want the form in your website html  -->
<div class="sib-form" style="text-align: center;
         background-color: transparent;                                 ">
  <div id="sib-form-container" class="sib-form-container">
    <div id="error-message" class="sib-form-message-panel" style="font-size:16px; text-align:left; font-family:Helvetica, sans-serif; color:#661d1d; background-color:#ffeded; border-radius:3px; border-color:#ff4949;max-width:540px;">
      <div class="sib-form-message-panel__text sib-form-message-panel__text--center">
        <svg viewBox="0 0 512 512" class="sib-icon sib-notification__icon">
          <path d="M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-11.49 120h22.979c6.823 0 12.274 5.682 11.99 12.5l-7 168c-.268 6.428-5.556 11.5-11.99 11.5h-8.979c-6.433 0-11.722-5.073-11.99-11.5l-7-168c-.283-6.818 5.167-12.5 11.99-12.5zM256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28z" />
        </svg>
        <span class="sib-form-message-panel__inner-text">
                          Ihre Formulareinsendung konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.
                      </span>
      </div>
    </div>
    <div></div>
    <div id="success-message" class="sib-form-message-panel" style="font-size:16px; text-align:left; font-family:Helvetica, sans-serif; color:#085229; background-color:#e7faf0; border-radius:3px; border-color:#13ce66;max-width:540px;">
      <div class="sib-form-message-panel__text sib-form-message-panel__text--center">
        <svg viewBox="0 0 512 512" class="sib-icon sib-notification__icon">
          <path d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 464c-118.664 0-216-96.055-216-216 0-118.663 96.055-216 216-216 118.664 0 216 96.055 216 216 0 118.663-96.055 216-216 216zm141.63-274.961L217.15 376.071c-4.705 4.667-12.303 4.637-16.97-.068l-85.878-86.572c-4.667-4.705-4.637-12.303.068-16.97l8.52-8.451c4.705-4.667 12.303-4.637 16.97.068l68.976 69.533 163.441-162.13c4.705-4.667 12.303-4.637 16.97.068l8.451 8.52c4.668 4.705 4.637 12.303-.068 16.97z" />
        </svg>
        <span class="sib-form-message-panel__inner-text">
                          Ihre Formulareinsendung war erfolgreich.
                      </span>
      </div>
    </div>
    <div></div>
    <div id="sib-container" class="sib-container--large sib-container--vertical" style="text-align:center; background-color:rgba(255,255,255,1); max-width:540px; border-radius:3px; border-width:1px; border-color:#C0CCD9; border-style:solid; direction:ltr">
      <form id="sib-form" method="POST" action="https://e008a42a.sibforms.com/serve/MUIFAG9acSp9b_pex1z99SWfeLUbHmdx6QrclqWkiIk8R3JqIQToJVIjZZEChngxhV-TpwkSg9kJE0YTD-74bWdRCiuQbMMfRyomJWPYhLchL3KMHBDokZX3_pYTC2DlYRPNSzQrC7ZCjmRvSyvPQTPj1hvXv89E5oCQDwL4zTUFcpZFxTIkGcDA7PtUrsxlLZ3HDdxmM0NHWQ2L" data-type="subscription">
        <div style="padding: 8px 0;">
          <div class="sib-form-block" style="font-size:20px; text-align:left; font-weight:700; font-family:Helvetica, sans-serif; color:#3C4858; background-color:transparent; text-align:left">
            <p>Möchtest du dein Kind für den Kunstkaleidoskop-Wettbewerb anmelden? Fülle einfach die Pflichtfelder dieses Formulars aus und der Wettbewerb kann beginnen.</p>
          </div>
        </div>
        <div style="padding: 8px 0;">
          <div class="sib-form-block" style="font-size:20px; text-align:left; font-weight:700; font-family:Helvetica, sans-serif; color:#3C4858; background-color:transparent; text-align:left">
            <div class="sib-text-form-block">
              <p>Deine Daten:</p>
            </div>
          </div>
        </div>
        <div style="padding: 8px 0;">
          <div class="sib-input sib-form-block">
            <div class="form__entry entry_block">
              <div class="form__label-row ">
                <label class="entry__label" style="font-weight: 500; text-align:left; font-size:16px; text-align:left; font-family:Helvetica, sans-serif; color:#3c4858;" for="FIRSTNAME" data-required="*">Vorname</label>

                <div class="entry__field">
                  <input class="input " maxlength="200" type="text" id="FIRSTNAME" name="FIRSTNAME" autocomplete="off" placeholder="Vorname" data-required="true" required />
                </div>
              </div>

              <label class="entry__error entry__error--primary" style="font-size:16px; text-align:left; font-family:Helvetica, sans-serif; color:#661d1d; background-color:#ffeded; border-radius:3px; border-color:#ff4949;">
              </label>
            </div>
          </div>
        </div>
        <div style="padding: 8px 0;">
          <div class="sib-input sib-form-block">
            <div class="form__entry entry_block">
              <div class="form__label-row ">
                <label class="entry__label" style="font-weight: 500; text-align:left; font-size:16px; text-align:left; font-family:Helvetica, sans-serif; color:#3c4858;" for="LASTNAME" data-required="*">Nachname</label>

                <div class="entry__field">
                  <input class="input " maxlength="200" type="text" id="LASTNAME" name="LASTNAME" autocomplete="off" placeholder="Nachname" data-required="true" required />
                </div>
              </div>

              <label class="entry__error entry__error--primary" style="font-size:16px; text-align:left; font-family:Helvetica, sans-serif; color:#661d1d; background-color:#ffeded; border-radius:3px; border-color:#ff4949;">
              </label>
            </div>
          </div>
        </div>
        <div style="padding: 8px 0;">
          <div class="sib-input sib-form-block">
            <div class="form__entry entry_block">
              <div class="form__label-row ">
                <label class="entry__label" style="font-weight: 500; text-align:left; font-size:16px; text-align:left; font-family:Helvetica, sans-serif; color:#3c4858;" for="EMAIL" data-required="*">E-Mail</label>

                <div class="entry__field">
                  <input class="input " type="text" id="EMAIL" name="EMAIL" autocomplete="off" placeholder="E-Mail" data-required="true" required />
                </div>
              </div>

              <label class="entry__error entry__error--primary" style="font-size:16px; text-align:left; font-family:Helvetica, sans-serif; color:#661d1d; background-color:#ffeded; border-radius:3px; border-color:#ff4949;">
              </label>
            </div>
          </div>
        </div>
        <div style="padding: 8px 0;">
          <div class="sib-sms-field sib-form-block">
            <div class="form__entry entry_block">
              <div class="form__label-row ">
                <label class="entry__label" style="font-weight: 500; text-align:left; font-size:16px; text-align:left; font-family:Helvetica, sans-serif; color:#3c4858;" for="SMS">Telefonnummer</label>

                <div class="sib-sms-input-wrapper" style="direction:ltr">
                  <div class="sib-sms-input" data-placeholder="Telefonnummer" data-required="" data-country-code="DE" data-whatsapp-country-code="DE" data-value="" data-whatsappvalue="" data-attributename="SMS">
                    <div class="entry__field">
                      <select class="input" name="SMS__COUNTRY_CODE">
<option value="+93">+93 Afghanistan</option>
<option value="+355">+355 Albanien</option>
<option value="+213">+213 Algerien</option>
<option value="+1684">+1684 Amerikanisch-Samoa</option>
<option value="+1340">+1340 Amerikanische Jungferninseln</option>
<option value="+376">+376 Andorra</option>
<option value="+244">+244 Angola</option>
<option value="+1264">+1264 Anguilla</option>
<option value="+672">+672 Antarktis</option>
<option value="+1268">+1268 Antigua und Barbuda</option>
<option value="+240">+240 Äquatorialguinea</option>
<option value="+54">+54 Argentinien</option>
<option value="+374">+374 Armenien</option>
<option value="+297">+297 Aruba</option>
<option value="+994">+994 Aserbaidschan</option>
<option value="+251">+251 Äthiopien</option>
<option value="+61">+61 Australien</option>
<option value="+1242">+1242 Bahamas</option>
<option value="+973">+973 Bahrain</option>
<option value="+880">+880 Bangladesch</option>
<option value="+1246">+1246 Barbados</option>
<option value="+32">+32 Belgien</option>
<option value="+501">+501 Belize</option>
<option value="+229">+229 Benin</option>
<option value="+1441">+1441 Bermuda</option>
<option value="+975">+975 Bhutan</option>
<option value="+591">+591 Bolivien</option>
<option value="+599">+599 Bonaire, Sint Eustatius und Saba</option>
<option value="+387">+387 Bosnien und Herzegowina</option>
<option value="+267">+267 Botswana</option>
<option value="+47">+47 Bouvetinsel</option>
<option value="+55">+55 Brasilien</option>
<option value="+246">+246 Britisches Territorium im Indischen Ozean</option>
<option value="+1284">+1284 Britische Jungferninseln</option>
<option value="+673">+673 Brunei</option>
<option value="+359">+359 Bulgarien</option>
<option value="+226">+226 Burkina Faso</option>
<option value="+257">+257 Burundi</option>
<option value="+56">+56 Chile</option>
<option value="+86">+86 China</option>
<option value="+682">+682 Cookinseln</option>
<option value="+506">+506 Costa Rica</option>
<option value="+599">+599 Curaçao</option>
<option value="+45">+45 Dänemark</option>
<option value="+49">+49 Deutschland</option>
<option value="+1767">+1767 Dominica</option>
<option value="+1809">+1809 Dominikanische Republik</option>
<option value="+1829">+1829 Dominikanische Republik</option>
<option value="+1849">+1849 Dominikanische Republik</option>
<option value="+253">+253 Dschibuti</option>
<option value="+593">+593 Ecuador</option>
<option value="+225">+225 Elfenbeinküste</option>
<option value="+503">+503 El Salvador</option>
<option value="+291">+291 Eritrea</option>
<option value="+372">+372 Estland</option>
<option value="+268">+268 Eswatini</option>
<option value="+500">+500 Falklandinseln</option>
<option value="+298">+298 Färöer</option>
<option value="+679">+679 Fidschi</option>
<option value="+358">+358 Finnland</option>
<option value="+33">+33 Frankreich</option>
<option value="+594">+594 Französisch-Guayana</option>
<option value="+689">+689 Französisch-Polynesien</option>
<option value="+262">+262 Französische Süd- und Antarktisgebiete</option>
<option value="+241">+241 Gabun</option>
<option value="+220">+220 Gambia</option>
<option value="+995">+995 Georgien</option>
<option value="+233">+233 Ghana</option>
<option value="+350">+350 Gibraltar</option>
<option value="+1473">+1473 Grenada</option>
<option value="+30">+30 Griechenland</option>
<option value="+299">+299 Grönland</option>
<option value="+44">+44 Großbritannien</option>
<option value="+590">+590 Guadeloupe</option>
<option value="+1671">+1671 Guam</option>
<option value="+502">+502 Guatemala</option>
<option value="+44">+44 Guernsey</option>
<option value="+224">+224 Guinea</option>
<option value="+245">+245 Guinea-Bissau</option>
<option value="+592">+592 Guyana</option>
<option value="+509">+509 Haiti</option>
<option value="+672">+672 Heard und McDonaldinseln</option>
<option value="+504">+504 Honduras</option>
<option value="+852">+852 Hongkong</option>
<option value="+91">+91 Indien</option>
<option value="+62">+62 Indonesien</option>
<option value="+44">+44 Insel Man</option>
<option value="+964">+964 Irak</option>
<option value="+98">+98 Iran</option>
<option value="+353">+353 Irland</option>
<option value="+354">+354 Island</option>
<option value="+972">+972 Israel</option>
<option value="+39">+39 Italien</option>
<option value="+1876">+1876 Jamaika</option>
<option value="+81">+81 Japan</option>
<option value="+967">+967 Jemen</option>
<option value="+44">+44 Jersey</option>
<option value="+962">+962 Jordanien</option>
<option value="+1345">+1345 Kaimaninseln</option>
<option value="+855">+855 Kambodscha</option>
<option value="+237">+237 Kamerun</option>
<option value="+1">+1 Kanada</option>
<option value="+34">+34 Kanarische Inseln</option>
<option value="+238">+238 Kap Verde</option>
<option value="+7">+7 Kasachstan</option>
<option value="+974">+974 Katar</option>
<option value="+254">+254 Kenia</option>
<option value="+996">+996 Kirgisistan</option>
<option value="+686">+686 Kiribati</option>
<option value="+57">+57 Kolumbien</option>
<option value="+269">+269 Komoren</option>
<option value="+242">+242 Republik Kongo</option>
<option value="+243">+243 Demokratische Republik Kongo</option>
<option value="+383">+383 Kosovo</option>
<option value="+385">+385 Kroatien</option>
<option value="+53">+53 Kuba</option>
<option value="+965">+965 Kuwait</option>
<option value="+856">+856 Laos</option>
<option value="+266">+266 Lesotho</option>
<option value="+371">+371 Lettland</option>
<option value="+961">+961 Libanon</option>
<option value="+231">+231 Liberia</option>
<option value="+218">+218 Libyen</option>
<option value="+423">+423 Liechtenstein</option>
<option value="+370">+370 Litauen</option>
<option value="+352">+352 Luxemburg</option>
<option value="+853">+853 Macau</option>
<option value="+261">+261 Madagaskar</option>
<option value="+265">+265 Malawi</option>
<option value="+60">+60 Malaysia</option>
<option value="+960">+960 Malediven</option>
<option value="+223">+223 Mali</option>
<option value="+356">+356 Malta</option>
<option value="+212">+212 Marokko</option>
<option value="+692">+692 Marshallinseln</option>
<option value="+596">+596 Martinique</option>
<option value="+222">+222 Mauretanien</option>
<option value="+230">+230 Mauritius</option>
<option value="+262">+262 Mayotte</option>
<option value="+52">+52 Mexiko</option>
<option value="+691">+691 Mikronesien</option>
<option value="+373">+373 Moldau</option>
<option value="+377">+377 Monaco</option>
<option value="+976">+976 Mongolei</option>
<option value="+382">+382 Montenegro</option>
<option value="+1664">+1664 Montserrat</option>
<option value="+258">+258 Mosambik</option>
<option value="+95">+95 Myanmar</option>
<option value="+264">+264 Namibia</option>
<option value="+674">+674 Nauru</option>
<option value="+977">+977 Nepal</option>
<option value="+687">+687 Neukaledonien</option>
<option value="+64">+64 Neuseeland</option>
<option value="+505">+505 Nicaragua</option>
<option value="+31">+31 Niederlande</option>
<option value="+227">+227 Niger</option>
<option value="+234">+234 Nigeria</option>
<option value="+683">+683 Niue</option>
<option value="+672">+672 Norfolkinsel</option>
<option value="+389">+389 Nordmazedonien</option>
<option value="+1670">+1670 Nördliche Marianen</option>
<option value="+850">+850 Nordkorea</option>
<option value="+47">+47 Norwegen</option>
<option value="+968">+968 Oman</option>
<option value="+43">+43 Österreich</option>
<option value="+670">+670 Osttimor</option>
<option value="+92">+92 Pakistan</option>
<option value="+680">+680 Palau</option>
<option value="+970">+970 Palästina</option>
<option value="+507">+507 Panama</option>
<option value="+675">+675 Papua-Neuguinea</option>
<option value="+595">+595 Paraguay</option>
<option value="+51">+51 Peru</option>
<option value="+63">+63 Philippinen</option>
<option value="+64">+64 Pitcairninseln</option>
<option value="+48">+48 Polen</option>
<option value="+351">+351 Portugal</option>
<option value="+1787">+1787 Puerto Rico</option>
<option value="+262">+262 Réunion</option>
<option value="+250">+250 Ruanda</option>
<option value="+40">+40 Rumänien</option>
<option value="+7">+7 Russland</option>
<option value="+677">+677 Salomonen</option>
<option value="+685">+685 Samoa</option>
<option value="+378">+378 San Marino</option>
<option value="+239">+239 São Tomé und Príncipe</option>
<option value="+966">+966 Saudi-Arabien</option>
<option value="+46">+46 Schweden</option>
<option value="+41">+41 Schweiz</option>
<option value="+221">+221 Senegal</option>
<option value="+381">+381 Serbien</option>
<option value="+248">+248 Seychellen</option>
<option value="+232">+232 Sierra Leone</option>
<option value="+263">+263 Simbabwe</option>
<option value="+65">+65 Singapur</option>
<option value="+1721">+1721 Sint Maarten</option>
<option value="+421">+421 Slowakei</option>
<option value="+386">+386 Slowenien</option>
<option value="+252">+252 Somalia</option>
<option value="+34">+34 Spanien</option>
<option value="+94">+94 Sri Lanka</option>
<option value="+290">+290 St. Helena</option>
<option value="+1869">+1869 St. Kitts und Nevis</option>
<option value="+1758">+1758 St. Lucia</option>
<option value="+590">+590 St. Martin</option>
<option value="+508">+508 St. Pierre und Miquelon</option>
<option value="+1784">+1784 St. Vincent und die Grenadinen</option>
<option value="+27">+27 Südafrika</option>
<option value="+249">+249 Sudan</option>
<option value="+500">+500 Südgeorgien und die Südlichen Sandwichinseln</option>
<option value="+82">+82 Südkorea</option>
<option value="+211">+211 Südsudan</option>
<option value="+597">+597 Suriname</option>
<option value="+47">+47 Svalbard und Jan Mayen</option>
<option value="+963">+963 Syrien</option>
<option value="+992">+992 Tadschikistan</option>
<option value="+886">+886 Taiwan</option>
<option value="+255">+255 Tansania</option>
<option value="+66">+66 Thailand</option>
<option value="+228">+228 Togo</option>
<option value="+690">+690 Tokelau</option>
<option value="+676">+676 Tonga</option>
<option value="+1868">+1868 Trinidad und Tobago</option>
<option value="+235">+235 Tschad</option>
<option value="+420">+420 Tschechien</option>
<option value="+216">+216 Tunesien</option>
<option value="+90">+90 Türkei</option>
<option value="+993">+993 Turkmenistan</option>
<option value="+1649">+1649 Turks- und Caicosinseln</option>
<option value="+688">+688 Tuvalu</option>
<option value="+256">+256 Uganda</option>
<option value="+380">+380 Ukraine</option>
<option value="+36">+36 Ungarn</option>
<option value="+246">+246 Amerikanische Überseeinseln</option>
<option value="+598">+598 Uruguay</option>
<option value="+1">+1 USA</option>
<option value="+998">+998 Usbekistan</option>
<option value="+379">+379 Vatikanstadt</option>
<option value="+58">+58 Venezuela</option>
<option value="+971">+971 Vereinigte Arabische Emirate</option>
<option value="+84">+84 Vietnam</option>
<option value="+678">+678 Vanuatu</option>
<option value="+681">+681 Wallis und Futuna</option>
<option value="+375">+375 Weißrussland</option>
<option value="+212">+212 Westsahara</option>
<option value="+236">+236 Zentralafrikanische Republik</option>
<option value="+357">+357 Zypern</option>
                      </select>
                    </div>
                    <div class="entry__field" style="width: 100%">
                      <input type="tel" type="text" class="input" id="SMS" name="SMS" autocomplete="off" placeholder="Telefonnummer" />
                    </div>
                  </div>
                  <div class="sib-sms-tooltip telefonnummer-removal">
                    <div class="sib-sms-tooltip__box">
                      The SMS field must contain between 6 and 19 digits and include the country code without using +/0 (e.g. 1xxxxxxxxxx for the United States)
                    </div>
                    <span class="sib-sms-tooltip__icon">?</span>
                  </div>
                </div>
              </div>

              <label class="entry__error entry__error--primary" style="font-size:16px; text-align:left; font-family:Helvetica, sans-serif; color:#661d1d; background-color:#ffeded; border-radius:3px; border-color:#ff4949;">
              </label>
              <label class="entry__error entry__error--secondary" style="font-size:16px; text-align:left; font-family:Helvetica, sans-serif; color:#661d1d; background-color:#ffeded; border-radius:3px; border-color:#ff4949;">
              </label>
            </div>
          </div>
        </div>
        <div style="padding: 8px 0;">

          <div class="sib-input  sib-form-block geburtsdatum-removal">
            <div class="form__entry">
              <div class="form__label-row ">
                <label class="entry__label" style="font-weight: 500; text-align:left; font-size:16px; text-align:left; font-family:Helvetica, sans-serif; color:#3c4858;" for="GEBURTSDATUM">Geburtsdatum</label>
                <div class="entry__field">
<input maxlength="200" type="text" data-type="date" class="input " pattern="^([0-2][0-9]|(3)[0-1])(-)(((0)[0-9])|((1)[0-2]))(-)\\d{4}$" title="dd-mm-yyyy" data-format="dd-mm-yyyy" id="GEBURTSDATUM" name="GEBURTSDATUM" autocomplete="off" placeholder="Geburtsdatum">
                </div>
              </div>
              <label class="entry__error entry__error--primary" style="font-size:16px; text-align:left; font-family:Helvetica, sans-serif; color:#661d1d; background-color:#ffeded; border-radius:3px; border-color:#ff4949;">
              </label>
              <label class="entry__specification" style="font-size:12px; text-align:left; font-family:Helvetica, sans-serif; color:#8390A4; text-align:left">
                dd-mm-yyyy
              </label>
            </div>
          </div>
        </div>
        <div style="padding: 8px 0;">
          <div class="sib-form-block" style="font-size:20px; text-align:left; font-weight:700; font-family:Helvetica, sans-serif; color:#3C4858; background-color:transparent; text-align:left">
            <div class="sib-text-form-block schulkind">
              <p>Die Daten des Schulkindes:</p>
              <div class="sib-sms-tooltip">
                <div class="sib-sms-tooltip__box">
Wir benötigen die Daten des Schulkindes, um die Teilnahme am Wettbewerb eindeutig zuzuordnen und eine faire Durchführung zu gewährleisten, die niemanden benachteiligt oder zu Verwechselungen führt.
                </div>
                <span class="sib-sms-tooltip__icon">!</span>
              </div>
            </div>
          </div>
        </div>
        <div style="padding: 8px 0;">
          <div class="sib-input sib-form-block">
            <div class="form__entry entry_block">
              <div class="form__label-row ">
                <label class="entry__label" style="font-weight: 500; text-align:left; font-size:16px; text-align:left; font-family:Helvetica, sans-serif; color:#3c4858;" for="FIRSTNAME_KIND" data-required="*">Vorname</label>

                <div class="entry__field">
                  <input class="input " maxlength="200" type="text" id="FIRSTNAME_KIND" name="FIRSTNAME_KIND" autocomplete="off" placeholder="Vorname" data-required="true" required />
                </div>
              </div>

              <label class="entry__error entry__error--primary" style="font-size:16px; text-align:left; font-family:Helvetica, sans-serif; color:#661d1d; background-color:#ffeded; border-radius:3px; border-color:#ff4949;">
              </label>
            </div>
          </div>
        </div>
        <div style="padding: 8px 0;">
          <div class="sib-input sib-form-block">
            <div class="form__entry entry_block">
              <div class="form__label-row ">
                <label class="entry__label" style="font-weight: 500; text-align:left; font-size:16px; text-align:left; font-family:Helvetica, sans-serif; color:#3c4858;" for="LASTNAME_KIND" data-required="*">Nachname</label>

                <div class="entry__field">
                  <input class="input " maxlength="200" type="text" id="LASTNAME_KIND" name="LASTNAME_KIND" autocomplete="off" placeholder="Nachname" data-required="true" required />
                </div>
              </div>

              <label class="entry__error entry__error--primary" style="font-size:16px; text-align:left; font-family:Helvetica, sans-serif; color:#661d1d; background-color:#ffeded; border-radius:3px; border-color:#ff4949;">
              </label>
            </div>
          </div>
        </div>

<div style="padding: 8px 0;">
  <div class="sib-input sib-form-block">
    <div class="form__entry entry_block">
      <div class="form__label-row ">
        <label class="entry__label" style="font-weight: 500; text-align:left; font-size:16px; text-align:left; font-family:Helvetica, sans-serif; color:#3c4858;" for="BENUTZERNAME_KK" data-required="*">Welchen Künstlernamen soll das Kind haben?</label>

        <div class="entry__field">
          <input class="input "
                 minlength="2"
                 maxlength="20"
                 type="text"
                 id="BENUTZERNAME_KK"
                 name="BENUTZERNAME_KK"
                 autocomplete="off"
                 placeholder="Künstlername"
                 pattern="^[a-zA-Z0-9._]{2,20}$"
                 title="Der Künstlername muss zwischen 2 und 20 Zeichen lang sein und darf nur lateinische Buchstaben, Zahlen, Punkte (.) und Unterstriche (_) enthalten."
                 data-required="true"
                 required />
        </div>
      </div>

      <label class="entry__error entry__error--primary" style="font-size:16px; text-align:left; font-family:Helvetica, sans-serif; color:#661d1d; background-color:#ffeded; border-radius:3px; border-color:#ff4949;">
      </label>
      <label class="entry__specification" style="font-size:12px; text-align:left; font-family:Helvetica, sans-serif; color:#8390A4; text-align:left">
        2-20 Zeichen: nur Buchstaben, Zahlen, Punkt (.) und Unterstrich (_)
      </label>
    </div>
  </div>
</div>

        <div style="padding: 8px 0;">
          <div class="sib-input sib-form-block">
            <div class="form__entry entry_block">
              <div class="form__label-row ">
                <label class="entry__label" style="font-weight: 500; text-align:left; font-size:16px; text-align:left; font-family:Helvetica, sans-serif; color:#3c4858;" for="ALTER_KIND">Wie alt ist das Kind?</label>
                <div class="entry__field">
                  <input maxlength="200" type="text" data-numeric="true" class="input " id="ALTER_KIND" name="ALTER_KIND" autocomplete="off" placeholder="Zahl eingeben" />
                </div>
              </div>
              <label class="entry__error entry__error--primary" style="font-size:16px; text-align:left; font-family:Helvetica, sans-serif; color:#661d1d; background-color:#ffeded; border-radius:3px; border-color:#ff4949;">
              </label>
            </div>
          </div>
        </div>
        <div style="padding: 8px 0;">
          <div class="sib-input sib-form-block">
            <div class="form__entry entry_block">
              <div class="form__label-row ">
                <label class="entry__label" style="font-weight: 500; text-align:left; font-size:16px; text-align:left; font-family:Helvetica, sans-serif; color:#3c4858;" for="ANMERKUNG_ERLAUBNIS">Anmerkungen</label>

                <div class="entry__field">
                  <textarea rows="2" class="input " maxlength="500" id="ANMERKUNG_ERLAUBNIS" name="ANMERKUNG_ERLAUBNIS" autocomplete="off"></textarea>
                </div>
              </div>

              <label class="entry__error entry__error--primary" style="font-size:16px; text-align:left; font-family:Helvetica, sans-serif; color:#661d1d; background-color:#ffeded; border-radius:3px; border-color:#ff4949;">
              </label>
            </div>
          </div>
        </div>
        <div style="padding: 8px 0;">
          <div class="sib-optin sib-form-block" data-required="true">
            <div class="form__entry entry_mcq">
              <div class="form__label-row ">
                <div class="entry__choice" style="">
                  <label>
                    <input type="checkbox" class="input_replaced" value="1" id="IST_VOLLJAEHRIG" name="IST_VOLLJAEHRIG" required />
                    <span class="checkbox checkbox_tick_positive"
            style="margin-left:"
            ></span><span style="font-size:14px; text-align:left; font-family:Helvetica, sans-serif; color:#3C4858; background-color:transparent;"><p>Ich bin über 18 Jahre alt und Elternteil des Kindes.</p><span data-required="*" style="display: inline;" class="entry__label entry__label_optin"></span></span> </label>
                </div>
              </div>
              <label class="entry__error entry__error--primary" style="font-size:16px; text-align:left; font-family:Helvetica, sans-serif; color:#661d1d; background-color:#ffeded; border-radius:3px; border-color:#ff4949;">
              </label>
            </div>
          </div>
        </div>
        <div style="padding: 8px 0;">
          <div class="sib-optin sib-form-block" data-required="true">
            <div class="form__entry entry_mcq">
              <div class="form__label-row ">
                <div class="entry__choice" style="">
                  <label>
                    <input type="checkbox" class="input_replaced" value="1" id="OPT_IN" name="OPT_IN" required />
                    <span class="checkbox checkbox_tick_positive"
            style="margin-left:"
            ></span><span style="font-size:14px; text-align:left; font-family:Helvetica, sans-serif; color:#3C4858; background-color:transparent;"><p>Ich habe die Datenschutzbestimmungen gelesen und stimme dem Erhalt des Newsletters zu.</p><span data-required="*" style="display: inline;" class="entry__label entry__label_optin"></span></span> </label>
                </div>
              </div>
              <label class="entry__error entry__error--primary" style="font-size:16px; text-align:left; font-family:Helvetica, sans-serif; color:#661d1d; background-color:#ffeded; border-radius:3px; border-color:#ff4949;">
              </label>
            </div>
          </div>
        </div>
        <div style="padding: 8px 0;">
          <div class="sib-form-block" style="text-align: center">
            <button class="sib-form-block__button sib-form-block__button-with-loader" style="font-size:16px; text-align:center; font-weight:700; font-family:Helvetica, sans-serif; color:#FFFFFF; background-color:#3E4857; border-radius:3px; border-width:0px;" form="sib-form" type="submit">
              <svg class="icon clickable__icon progress-indicator__icon sib-hide-loader-icon" viewBox="0 0 512 512" style="">
                <path d="M460.116 373.846l-20.823-12.022c-5.541-3.199-7.54-10.159-4.663-15.874 30.137-59.886 28.343-131.652-5.386-189.946-33.641-58.394-94.896-95.833-161.827-99.676C261.028 55.961 256 50.751 256 44.352V20.309c0-6.904 5.808-12.337 12.703-11.982 83.556 4.306 160.163 50.864 202.11 123.677 42.063 72.696 44.079 162.316 6.031 236.832-3.14 6.148-10.75 8.461-16.728 5.01z" />
              </svg>
              Senden
            </button>
          </div>
        </div>

        <input type="text" name="email_address_check" value="" class="input--hidden">
        <input type="hidden" name="locale" value="en">
      </form>
    </div>
  </div>
</div>
<!-- End Brevo Form -->`
          }}
        />
      </Box>
      
      <Footer />
    </Box>
  );
};

export default ErlaubnisPage;